<div class="width-1100">

  <mat-card class="toolbar-top">

    <mat-toolbar>

      <div class='title'>
        <mat-icon>change_history</mat-icon>
        <div>GN1</div>
      </div>

      <!--
      <div flex justify-content='flex-end' fxLayoutAlign="end">
        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">


        <a mat-button (click)="openDialog(null)">
          <mat-icon color='primary'>add_circle_outline</mat-icon>
        </a>

        <a mat-button (click)='file.click()'>
          <mat-icon color='primary'>upload</mat-icon>
        </a>

        <input id='selectedFile' style="display: none;" #file type="file" (change)="readCSVFile($event)" />
        
    

        <a mat-button (click)="getAnnuities()">
          annuites
        </a>



        <a mat-button (click)="makeFolders()">
          Folders
        </a>

      </div>
  -->
    </mat-toolbar>

  </mat-card>

  <mat-card>

    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
        <button mat-icon-button disabled></button>
        <mat-icon class="type-icon" [attr.aria-label]="node.type + 'icon'">
          {{ node.type ==='file' ? 'description' : 'folder' }}
        </mat-icon>
        {{node.name}}
      </mat-tree-node>

      <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
        <mat-icon class="type-icon" [attr.aria-label]="node.type + 'icon'">
          {{ node.type ==='file' ? 'description' : 'folder' }}
        </mat-icon>
        {{node.name}}
      </mat-tree-node>
    </mat-tree>

  </mat-card>

</div>